// client/src/views/Lobby.jsx
import React from 'react';
import { useLobbyController } from '@features/lobby/controllers/useLobbyController.js';
import Chat from '@features/lobby/components/Chat.jsx';
import UserList from '@features/lobby/components/UserList.jsx';
import '../style/Lobby.css';
import LobbySettingsModal from '@features/lobby/components/LobbySettingsModal.jsx';
import { getPersistentUserId } from '@api/userService.js';
import JoinPromptDialog from '@components/JoinPromptDialog.jsx';

export default function Lobby() {
    const {
        lobbyCode,
        isLoading,
        joinError,
        showJoinDialog,
        handleJoinDialogSubmit,
        forcePassword,
        users,
        userName,
        isCreator,
        showSettingsModal,
        setShowSettingsModal,
        settings,
        setSettings,
        copied,
        setCopied,
        input,
        setInput,
        sendMessage,
        leaveLobby,
        handleToggleSpectator,
        handleKickUser,
        startGame,
        messages,
        navigate
    } = useLobbyController();

    return (
        <div className="lobby-container">
            {isLoading ? (
                <p>Lade Lobby...</p>
            ) : joinError ? (
                <div className="error-box">
                    <i className="fas fa-exclamation-triangle error-icon"></i>
                    <h2>Fehler</h2>
                    <p>{joinError}</p>
                    <button className="button button-danger" onClick={() => navigate('/')}>Zurück zur Startseite</button>
                </div>
            ) : (
                <>
                    {showJoinDialog && (
                        <JoinPromptDialog
                            lobbyCode={lobbyCode}
                            onSubmit={handleJoinDialogSubmit}
                            onClose={() => navigate('/')}
                            error={joinError}
                            forcePassword={forcePassword}
                        />
                    )}

                    {!showJoinDialog && (
                        <>
                            <header className="lobby-header">
                                <div className="lobby-title">
                                    <h1>Lobby:</h1>
                                    <div
                                        className={`lobby-code-box ${copied ? 'copied' : ''}`}
                                        onClick={() => {
                                            navigator.clipboard.writeText(lobbyCode);
                                            setCopied(true);
                                            setTimeout(() => setCopied(false), 2000);
                                        }}
                                        title="Klicken zum Kopieren"
                                    >
                                        <span>{lobbyCode}</span>
                                        <i className={`fas ${copied ? 'fa-check' : 'fa-copy'} copy-icon`} />
                                    </div>
                                </div>
                                <button onClick={leaveLobby} className="button button-danger">
                                    <i className="fas fa-sign-out-alt"></i>
                                    Lobby verlassen
                                </button>
                            </header>

                            <main className="lobby-main">
                                <section className="userlist-section">
                                    <div className="section-label">
                                        <i className="fas fa-users" />
                                        Spieler
                                    </div>
                                    <UserList
                                        users={users}
                                        onToggleSpectator={handleToggleSpectator}
                                        currentUserId={getPersistentUserId()}
                                        onKickUser={isCreator ? handleKickUser : undefined}
                                    />
                                </section>

                                <section className="chat-section">
                                    <div className="section-label" style={{ paddingTop: 16 }}>
                                        <i className="fas fa-comments" />
                                        Chat
                                    </div>
                                    <Chat
                                        messages={messages}
                                        input={input}
                                        setInput={setInput}
                                        sendMessage={sendMessage}
                                    />
                                </section>
                            </main>

                            {isCreator && (
                                <footer className="lobby-footer">
                                    <button onClick={() => setShowSettingsModal(true)} className="button button-secondary">
                                        <i className="fas fa-cog"></i> Lobby-Einstellungen
                                    </button>
                                    <button onClick={startGame} className="button button-primary">
                                        <i className="fas fa-play"></i> Start Game
                                    </button>
                                </footer>
                            )}

                            {showSettingsModal && (
                                <LobbySettingsModal
                                    onClose={() => setShowSettingsModal(false)}
                                    settings={settings}
                                    setSettings={setSettings}
                                />
                            )}
                        </>
                    )}
                </>
            )}
        </div>
    );
}